<app-request-form
    [sysText]="sysText"
    [anonymousRequestInfo]="anonymousNewRequestPage$ | async"
></app-request-form>